import * as React from 'react';
import { Fragment } from 'react';
import { isObservableArray } from 'mobx';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import StarRating from './StarRating';
import SRRI from './SRRI';
import ChangeIndicator from './ChangeIndicator';
import Translate from './Translate';

interface FundFactValue {
    theme?: { [property: string]: string | number };
    value: string | number | Array<string | number>;
    ui?: "srri" | "stars" | "starsOutOf";
    separator?: string;
    showChange?: boolean;
    higherRiskLabel?: string;
    lowerRiskLabel?: string;
}

export const FundFactValue: React.SFC<FundFactValue> = ({ ui, value, separator, showChange, higherRiskLabel, lowerRiskLabel }) => {
    if (ui === 'srri' && typeof value === 'number') {
        return (
            <SRRI
                rating={value}
                higherRiskLabel={higherRiskLabel}
                lowerRiskLabel={lowerRiskLabel}
            />
        );
    }

    if (ui === 'stars' && typeof value === 'number') {
        return (
            <StarRating
                rating={value}
            />
        );
    }

    if (ui === 'starsOutOf' && typeof value === 'number') {
        return (
            <StarRating
                showEmptyStars={true}
                rating={value}
            />
        );
    }

    return (
        <Fragment>
            {
                isObservableArray(value)
                    ? (value as Array<string | number>).join(separator || ", ")
                    : <Translate>{value}</Translate>
            }
            {separator}
            {
                showChange &&
                <ChangeIndicator value={value as number} />
            }
        </Fragment>
    );
};

export default observer(withTheme(FundFactValue));


// WEBPACK FOOTER //
// ./src/Components/FundFactValue.tsx